import React from "react";
import { useNavigate } from "react-router-dom";
import useClientConfig from "../../../../config/careers/clientConfig";
import "./css/styles.scss";

const CvmCultureLanding: React.FC = () => {
  const navigate = useNavigate();
  const { clientAssetsLink } = useClientConfig();

  return (
    <div className="cvm-culture-landing">

      {/* Hero */}
      <section className="cvmcl-hero">
        <video
          className="cvmcl-hero__video"
          src={`${clientAssetsLink}/Miami-Feature-MASTER-2409-60-sec-1-LR2.mp4`}
          autoPlay
          muted
          loop
          playsInline
        />
        <div className="cvmcl-hero__overlay" />
        <div className="cvmcl-hero__content">
          <h1 className="cvmcl-hero__title">CAREERS AT CVM</h1>
          <p className="cvmcl-hero__subtitle">
            If you love aquatics, recreation and want to grow within a team that
            backs you, you&apos;ll fit right in.
          </p>
          <button
            className="cvmcl-btn cvmcl-btn--teal"
            onClick={() => navigate("/jobs")}
          >
            View open roles
          </button>
        </div>
      </section>

      {/* Grow With Us */}
      <section className="cvmcl-split">
        <div className="cvmcl-split__media">
          <img
            src={`${clientAssetsLink}/CommitmentBanner.jpg`}
            alt="CVM team at work"
            className="cvmcl-split__img"
          />
        </div>
        <div className="cvmcl-split__body">
          <h2 className="cvmcl-split__heading">GROW WITH US</h2>
          <p className="cvmcl-split__text">
            We&apos;re always on the lookout for incredible people — and once
            you&apos;re in, we&apos;ll help you thrive in your role and beyond.
          </p>
          <button
            className="cvmcl-btn cvmcl-btn--outline"
            onClick={() => navigate("/jobs")}
          >
            Apply today
          </button>
        </div>
      </section>

      {/* Our Culture */}
      <section className="cvmcl-split cvmcl-split--flip">
        <div className="cvmcl-split__media">
          <img
            src={`${clientAssetsLink}/Drone-miami-2112-016-HERO.jpg`}
            alt="CVM culture"
            className="cvmcl-split__img"
          />
        </div>
        <div className="cvmcl-split__teal">
          <div className="cvmcl-split__body">
            <h2 className="cvmcl-split__heading cvmcl-split__heading--white">
              OUR CULTURE
            </h2>
            <p className="cvmcl-split__text cvmcl-split__text--white">
              We&apos;re not your average leisure organisation. Our mission — to
              enhance community wellbeing — means we do things differently.
            </p>
            <button
              className="cvmcl-btn cvmcl-btn--white-outline"
              onClick={() => navigate("/jobs")}
            >
              Learn more
            </button>
          </div>
        </div>
      </section>

      {/* Open Roles CTA */}
      <section
        className="cvmcl-cta"
        style={{ backgroundImage: `url(${clientAssetsLink}/LEADERSHIP.jpg)` }}
      >
        <div className="cvmcl-cta__overlay" />
        <div className="cvmcl-cta__content">
          <span className="cvmcl-cta__eyebrow">Want to join us?</span>
          <h2 className="cvmcl-cta__heading">CHECK OUT OUR OPEN ROLES</h2>
          <button
            className="cvmcl-btn cvmcl-btn--teal"
            onClick={() => navigate("/jobs")}
          >
            View open roles
          </button>
        </div>
      </section>

    </div>
  );
};

export default CvmCultureLanding;
